import { TextField } from '@mui/material';
import { outlinedInputClasses, styled } from '@mui/material';

import { COLOR_BORDER } from '~/components/App/theme';

export const StyledInput = styled(TextField)(({ theme: { palette } }) => ({
  [`& label.${outlinedInputClasses.focused}`]: {
    color: palette.secondary.main,
  },
  [`& div.${outlinedInputClasses.focused}`]: {
    background: palette.secondary.light,
  },
  [`& div.${outlinedInputClasses.error}`]: {
    background: palette.error.light,
  },
  [`& p.${outlinedInputClasses.error}`]: {
    color: palette.error.dark,
  },
  [`& .${outlinedInputClasses.root}`]: {
    marginTop: 0,
    background: palette.background.default,
    padding: 12,
    borderRadius: '6px',

    input: {
      padding: 0,
    },

    fieldset: {
      borderColor: COLOR_BORDER,
    },

    '&:hover fieldset': {
      borderColor: palette.secondary.dark,
      borderWidth: '2px',
    },

    [`&.${outlinedInputClasses.focused}`]: {
      color: palette.primary.dark,
      '& button': {
        background: palette.secondary.main,
        color: palette.background.paper,
      },
      '& fieldset': {
        borderColor: palette.secondary.dark,
      },
    },
    [`&.${outlinedInputClasses.error}`]: {
      '& fieldset': {
        borderColor: palette.error.main,
        borderWidth: '2px',
      },
      '& button': {
        background: palette.error.dark,
        color: palette.background.paper,
      },
    },
  },
}));
